import React, { useState, useEffect } from 'react';
import cmsFetch from '~/helpers/cms-fetch';
import { useDataFromPromise } from '~/helpers/page-data-utils';
import PutAway from '~/components/put-away/put-away';
import './shared.scss';
export function useSeenCounter(seenEnough) {
    var _a;
    const [counter, increment] = React.useReducer((s) => s + 1, Number((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.visitedGive) || 0);
    const hasBeenSeenEnough = React.useMemo(() => counter > seenEnough, [counter, seenEnough]);
    useEffect(() => {
        try {
            window.localStorage.visitedGive = String(counter);
        }
        catch (_a) {
            console.warn('LocalStorage restricted');
        }
    }, [counter]);
    return [hasBeenSeenEnough, increment];
}
export { PutAway };
export function usePutAway() {
    const [closed, setClosed] = useState(false);
    return [closed, () => React.createElement(PutAway, { onClick: () => setClosed(true) })];
}
// eslint-disable-next-line complexity
function getMode(stickyData) {
    var _a;
    if (!stickyData) {
        return null;
    }
    const expireDate = new Date((_a = stickyData.emergency_expires) !== null && _a !== void 0 ? _a : 0);
    const useEmergency = stickyData.emergency_expires && Date.now() < expireDate.getTime();
    if (useEmergency) {
        return 'emergency';
    }
    const startDate = new Date(stickyData.start);
    const endDate = new Date(stickyData.expires);
    const microdonationActive = startDate.getTime() < Date.now() && endDate.getTime() > Date.now();
    if (!microdonationActive) {
        return null;
    }
    return (stickyData.show_popup ? 'popup' : 'banner');
}
function useCampaign(stickyData) {
    const { start } = (stickyData || {});
    const mode = getMode(stickyData);
    useEffect(() => {
        if (mode && window.localStorage) {
            const campaignId = `${mode}-${start}`;
            const savedId = window.localStorage.campaignId;
            if (savedId !== campaignId) {
                window.localStorage.campaignId = campaignId;
                window.localStorage.visitedGive = '0';
            }
        }
    }, [start, mode]);
}
export function useStickyData() {
    var _a;
    const stickyDataPromise = React.useMemo(() => Promise.all([cmsFetch('sticky/'), cmsFetch('snippets/givebanner')])
        .then(([sd, bd]) => (Object.assign(Object.assign({}, sd), { bannerInfo: bd[0] }))), []);
    const stickyData = (_a = useDataFromPromise(stickyDataPromise)) !== null && _a !== void 0 ? _a : null;
    useCampaign(stickyData);
    const mode = getMode(stickyData);
    return React.useMemo(() => stickyData ? (Object.assign({ mode }, stickyData)) : null, [mode, stickyData]);
}
